import { createFileRoute } from "@tanstack/react-router";
import { TermlyPolicyPage } from "@/knowmeno/TermlyPolicyPage";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy — KnowMeno" },
      { name: "description", content: "How KnowMeno collects, uses, and protects your health and account data — written in plain English so you know exactly what stays yours." },
      { property: "og:title", content: "Privacy Policy — KnowMeno" },
      { property: "og:description", content: "How KnowMeno collects, uses, and protects your health and account data — written in plain English so you know exactly what stays yours." },
      { property: "og:url", content: "https://knowmeno.com/privacy" },
      { property: "og:type", content: "article" },
    ],
    links: [
      { rel: "canonical", href: "https://knowmeno.com/privacy" },
      { rel: "alternate", hrefLang: "en", href: "https://knowmeno.com/privacy" },
      { rel: "alternate", hrefLang: "x-default", href: "https://knowmeno.com/privacy" },
    ],
  }),
  component: () => (
    <TermlyPolicyPage dataId="8749a141-3105-456f-82d5-4d201c80c6cb" title="Privacy Policy" />
  ),
});
